import {
  RepaymentOption,
  RepaymentOptionType,
  ExistingLoanDetails,
} from "domain/indicativeRepaymentOptions";
import { money } from "util/money";
import { VisibleSection } from "./VisibleSection";
type RepaymentDetailsProps = {
  existingLoanDetails: ExistingLoanDetails;
  repaymentOption: RepaymentOption;
};

export const RepaymentDetails = ({
  existingLoanDetails,
  repaymentOption,
}: RepaymentDetailsProps) => {
  const visibleCRHExtendTerm =
    repaymentOption.optionType === RepaymentOptionType.CRHExtendTerm;
  const visibleCRHWithoutExtendTerm =
    repaymentOption.optionType === RepaymentOptionType.CRHWithoutExtendTerm;
  const visibleCIRHExtendTerm =
    repaymentOption.optionType === RepaymentOptionType.CIRHExtendTerm;
  const visibleCIRHWithoutExtendTerm =
    repaymentOption.optionType === RepaymentOptionType.CIRHWithoutExtendTerm;
  const visibleExtendTerm =
    repaymentOption.optionType === RepaymentOptionType.ExtendTerm;
  return (
    <>
      <VisibleSection visible={visibleCRHExtendTerm}>
        <div className="line-item line-space">
          After your Capital repayment holiday ends:
        </div>
        <div className="line-item">
          Your monthly repayment of
          <span className="oldValue">
            {money(repaymentOption.newMonthlyRepayment)}
          </span>
          will not change
        </div>
        <div className="line-item">
          You will still need to make
          <span className="oldValue">
            {repaymentOption.newRemainingTerm} monthly repayments
          </span>
        </div>
        <div className="line-item">
          You will pay
          <span className="oldValue">
            {money(repaymentOption.interestDuringHolidayTerm)}
          </span>
          of interest during the Capital repayment holiday
        </div>
        <div className="line-item last-line">
          You will pay
          <span className="oldValue">
            {money(
              repaymentOption.newTotalRepayment -
                existingLoanDetails.totalRepaymentAmount
            )}
          </span>
          more for your loan as the total amount repayable will increase to
          <span className="newValue">
            {money(repaymentOption.newTotalRepayment)}
          </span>
        </div>
      </VisibleSection>
      <VisibleSection visible={visibleCRHWithoutExtendTerm}>
        <div className="line-item line-space">
          After your Capital repayment holiday ends:
        </div>
        <div className="line-item">
          Your monthly repayment will be
          <span className="oldValue">
            {money(repaymentOption.newMonthlyRepayment)}
          </span>
          , this is
          <span className="newValue">
            {money(
              repaymentOption.newMonthlyRepayment -
                existingLoanDetails.monthlyRepaymentAmount
            )}
          </span>
          more each month
        </div>
        <div className="line-item">
          You will need to make
          <span className="oldValue">
            {repaymentOption.newRemainingTerm} monthly repayments
          </span>
        </div>
        <div className="line-item">
          You will pay
          <span className="oldValue">
            {money(repaymentOption.interestDuringHolidayTerm)}
          </span>
          of interest during the Capital repayment holiday
        </div>
        <div className="line-item last-line">
          You will pay
          <span className="oldValue">
            {money(
              repaymentOption.newTotalRepayment -
                existingLoanDetails.totalRepaymentAmount
            )}
          </span>
          more for your loan as the total amount repayable will increase to
          <span className="newValue">
            {money(repaymentOption.newTotalRepayment)}
          </span>
        </div>
      </VisibleSection>
      <VisibleSection visible={visibleCIRHWithoutExtendTerm}>
        <div className="line-item line-space">
          After your Capital & Interest repayment holiday ends:
        </div>
        <div className="line-item">
          Your monthly repayment will be
          <span className="oldValue">
            {money(repaymentOption.newMonthlyRepayment)}
          </span>
          , this is
          <span className="newValue">
            {money(
              repaymentOption.newMonthlyRepayment -
                existingLoanDetails.monthlyRepaymentAmount
            )}
          </span>
          more each month
        </div>
        <div className="line-item">
          You will need to make
          <span className="oldValue">
            {repaymentOption.newRemainingTerm} monthly repayments
          </span>
        </div>
        <div className="line-item last-line">
          You will pay
          <span className="oldValue">
            {money(
              repaymentOption.newTotalRepayment -
                existingLoanDetails.totalRepaymentAmount
            )}
          </span>
          more for your loan as the total amount repayable will increase to
          <span className="newValue">
            {money(repaymentOption.newTotalRepayment)}
          </span>
        </div>
      </VisibleSection>
      <VisibleSection visible={visibleCIRHExtendTerm}>
        <div className="line-item line-space">
          After your Capital & Interest repayment holiday ends:
        </div>
        <div className="line-item">
          Your monthly repayment will be
          <span className="oldValue">
            {money(repaymentOption.newMonthlyRepayment)}
          </span>
          , this is
          <span className="newValue">
            {money(
              repaymentOption.newMonthlyRepayment -
                existingLoanDetails.monthlyRepaymentAmount
            )}
          </span>
          more each month
        </div>
        <div className="line-item">
          You will still need to make
          <span className="oldValue">
            {repaymentOption.newRemainingTerm} monthly repayments
          </span>
        </div>
        <div className="line-item last-line">
          You will pay
          <span className="oldValue">
            {money(
              repaymentOption.newTotalRepayment -
                existingLoanDetails.totalRepaymentAmount
            )}
          </span>
          more for your loan as the total amount repayable will increase to
          <span className="newValue">
            {money(repaymentOption.newTotalRepayment)}
          </span>
        </div>
      </VisibleSection>
      <VisibleSection visible={visibleExtendTerm}>
        <div className="line-item">
          Your monthly repayments will be
          <span className="oldValue">
            {money(repaymentOption.newMonthlyRepayment)}
          </span>
          this is
          <span className="newValue">
            {money(
              existingLoanDetails.monthlyRepaymentAmount -
                repaymentOption.newMonthlyRepayment
            )}
          </span>
          less each month
        </div>
        <div className="line-item">
          You will need to make
          <span className="oldValue">{repaymentOption.newRemainingTerm}</span>
          repayments (that’s
          <span className="newValue">
            {repaymentOption.newRemainingTerm -
              existingLoanDetails.numberOfRepayments}
          </span>
          more)
        </div>
        <div className="line-item">
          You will pay
          <span className="oldValue">
            {money(
              repaymentOption.newTotalRepayment -
                existingLoanDetails.totalRepaymentAmount
            )}
          </span>
          more for your loan as the amount repayable will be
          <span className="newValue">
            {money(repaymentOption.newTotalRepayment)}
          </span>
        </div>
      </VisibleSection>
    </>
  );
};
